import { Routes } from '@angular/router';
import { mainLayoutRoutes } from './modules/main-layout/main-layout.routes';
import { LoginComponent } from './modules/auth/login/login.component';
import { AlreadyAuthenticatedGuard } from './core/guards/alreadyAuthenticatedGuard.guard';
import { authGuard } from './core/guards/auth.guard';
import { HomeComponent } from './pages/home/home.component';
import { PaymentRedirectComponent } from './modules/payment/payment-redirect/payment-redirect.component';
import { ForgotPasswordComponent } from './modules/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/main-layout/main-layout.routes').then(
        (m) => m.mainLayoutRoutes
      ),
    canActivate: [authGuard],
  },

  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AlreadyAuthenticatedGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'redirect',
    component: PaymentRedirectComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
];
